import { api, RouterOutput } from "../../services/rpc/RpcProvider";

export type TaskAssignment = RouterOutput["tasks"]["assignments"]["list"][0];

export const useTaskAssignments = (taskId: string) => {
  const { data: assignments, isLoading } = api.tasks.assignments.list.useQuery({ taskId });
  return { assignments, loading: isLoading };
};
